import React from "react";
import { Box } from "@chakra-ui/react";
import { translations } from "@/constants/translations";
import { useStore } from "@/store";
import { renderInnerHtml } from "@/helpers/dom";
import "./index.css";

export const GeneralTermsPage = () => {
  const { activeLanguage } = useStore();
  const language = translations.pages["general-terms"][activeLanguage];

  return <Box className="GeneralTerms">{renderInnerHtml(language)}</Box>;
};
